import type { Mission } from '../missions.ts'

export const cia: Mission = {
  id: "cia",
  name: "Central Intelligence Agency",
  short: "CIA",
  call: "Intelligence",
  kind: "independent",
  community: "intelligence",
  url: "https://www.cia.gov/",
  established: 1947,
  palette: {
    primary: "#162c77",
    secondary: "#6b0000",
    accent: "#fccc0f",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Central_Intelligence_Agency.svg",
  },
  motif: "star",
  mission: {
    text: "Our mission is straightforward but critical: leverage the power of information to keep our Nation safe.",
    url: "https://www.cia.gov/about/",
  },
  fact: {
    text: "The CIA seal features an eagle for alertness, a shield for defense, and a compass rose for global intelligence collection.",
    url: "https://www.cia.gov/about/",
  },
  seal: {
    file: "public/seals/cia.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Central_Intelligence_Agency.svg",
  },
  identifier: {
    about: "https://www.cia.gov/about/",
    foia: "https://www.cia.gov/readingroom/",
    noFear: "https://www.cia.gov/about/organization/equal-employment-opportunity/no-fear-act/",
    oig: "https://www.cia.gov/about/organization/inspector-general/",
    privacy: "https://www.cia.gov/about/organization/privacy-and-civil-liberties/",
  },
  media: {
    photos: [
      {
        file: "/media/cia-original-headquarters.jpg",
        small: "/media/cia-original-headquarters-sm.jpg",
        alt: "The long, low facade of the CIA Original Headquarters Building with its cantilevered concrete entrance canopy, under a blue sky with drifting clouds.",
        title: "Original Headquarters Building, Langley, Virginia",
        creator: "Central Intelligence Agency",
        source: "https://commons.wikimedia.org/wiki/File:Original_Headquarters_Building_(OHB)_-_Flickr_-_The_Central_Intelligence_Agency.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/cia-new-headquarters.jpg",
        small: "/media/cia-new-headquarters-sm.jpg",
        alt: "Close view of the CIA New Headquarters Building, a grid of pale green glass curtain wall panels stepping back across several stories.",
        title: "New Headquarters Building, Langley, Virginia",
        creator: "Central Intelligence Agency",
        source: "https://commons.wikimedia.org/wiki/File:New_Headquarters_Building_(NHB)_-_Flickr_-_The_Central_Intelligence_Agency.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
